import {
  IError,
  IProfile,
  IQueryHookOptions,
  IUpdateProfileRequest,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { createPearsonCandidate } from 'services';

type CreatePearsonCandidateFunction = UseMutateAsyncFunction<
  IProfile,
  IError,
  IUpdateProfileRequest
>;

type UseCreatePearsonCandidate = [
  CreatePearsonCandidateFunction,
  IQueryHookOptions,
];

export const useCreatePearsonCandidate = (): UseCreatePearsonCandidate => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfile,
    IError,
    IUpdateProfileRequest
  >((values: IUpdateProfileRequest) => createPearsonCandidate(values), {
    onSuccess: (data) => {
      queryClient.setQueryData('profile', data);
    },
  });
  return [mutateAsync, { error, isError, isLoading }];
};
